// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".center-shifter{display:grid;grid-template-columns:1fr;row-gap:4px}.center-shifter__input-line{align-items:center;display:flex}.center-shifter__input-display{flex:0 0 64px;margin-left:8px;text-align:right}.center-shifter__input-label{flex:0 0 auto;margin-right:8px;overflow:hidden}.center-shifter__input-element{flex:0 1 100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
